var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{key:_vm.fileRefKey,ref:_vm.attachmentId,staticStyle:{"display":"none"},attrs:{"accept":_vm.acceptFileType,"type":"file"},on:{"change":_vm.fileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }